import styled from "styled-components";

export const ToolTipSpan = styled.span`
  padding-left: 5px;
`;

export const titleSpan = styled.span`
  font-size: 16px;
  color: #000000;
  font-family: "DM Sans";
  font-weight: 500;
`;

export const AccordionImage = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 5px;
`;

export const AccordionContainer = styled.div`
  padding: 8px;
  /* box-shadow: 0px 4px 6px 0px #1f29370d, 0px 10px 15px 0px #1f29371a; */
  border: none;
  border-radius: 8px;
  margin-bottom: 10px;
  margin-top: 5px;
`;

export const AccordionSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 0;
`;

export const AccordionDetails = styled.div`
  padding: 0;
`;

export const RightIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 5px;
  cursor: pointer;
`;

export const SummaryContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;
